import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {TopeCanalFrecuencia} from '../_models/tope-canal-frecuencia';

@Injectable({
  providedIn: 'root'
})
export class TopeCanalFrecuenciaService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/topesCanalesFrecuencias';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado(): Observable<TopeCanalFrecuencia[]> {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as TopeCanalFrecuencia[] ) );
  }

  listadoHabilitados(): Observable<TopeCanalFrecuencia[]> {
    return this.httpClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as TopeCanalFrecuencia[] ) );
  }

  obtenerPorId( id: string ): Observable<TopeCanalFrecuencia> {
    return this.httpClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as TopeCanalFrecuencia ) );
  }

  obtenerPorIdTopeCanal(id: string): Observable<TopeCanalFrecuencia[]> {
    return this.httpClient.get( this.rutServicio + '/topeCanal/' + id ).pipe( map( res => res as TopeCanalFrecuencia[] ) );
  }

  obtenerPorIdTopeCanalHabilitado(id: string): Observable<TopeCanalFrecuencia[]> {
    return this.httpClient.get( this.rutServicio + '/topeCanal/' + id + '/enabled').pipe( map( res => res as TopeCanalFrecuencia[] ) );
  }

  crear( regCrear: TopeCanalFrecuencia ): Observable<TopeCanalFrecuencia> {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as TopeCanalFrecuencia ) );
  }

  bulk( regBulk: TopeCanalFrecuencia[] ) {
    regBulk.map( ( s: TopeCanalFrecuencia ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + '/bulk', regBulk ).pipe( map( res => res as any ) );
  }

  actualizar( regActualizar: TopeCanalFrecuencia ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
